/**
 * Copyright (c) 2017-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

export { subscribe, createSourceEventStream } from './subscribe';


//////////////////
// WEBPACK FOOTER
// ../~/graphql/module/subscription/index.js
// module id = 792
// module chunks = 0